module.exports = __webpack_public_path__ + "static/media/multiState.f23d395d.png";